import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../config/app-config';
import { map } from 'rxjs/operators';
// import {DOCUMENT} from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { CONFIGCONSTANTS } from '../config/app-constants';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  setting: any = {};
  logodata:any;
  favdetails:any;
  logodetail:any;
  Data:any;  constructor( private http: HttpClient, @Inject(DOCUMENT) private _document: HTMLDocument ) { }

  /* Get Response of the Settings Data */
  getSettingsDataURL() {
    /* added {} as empty parameter due POST method but need to remove {} and replace POST Method to GET Method */
  	return this.http.post<any>(CONFIG.getSettingsDataURL, {})    .pipe(map(response => {
        return response;
    }));
  }

  /* SAVE Data to the Settings Data */
  updateSettingsDataURL(SettingsData: any) {
  	return this.http.post<any>(CONFIG.getSettingsSaveDataURL, SettingsData)
    .pipe(map(response => {
        return response;
    }));
  }

  /* Get Image URL */
  getSettingsImageDataURL() {
  	return this.http.get<any>(CONFIG.getSettingsImageDataURL)
    .pipe(map(response => {
      this.Data = response;
        return response;
    }));
  }

  /* Delete Image on basis of ID value */
  removeImage(id: number) {
    return this.http.get<any>(CONFIG.getSettingsRemoveImageURL + id)
    .pipe(map(response => {
        return response;
    }));
  }
  changeFavicon(href: string): void {
    this._document.getElementById('appFavicon').setAttribute('href', href);
  }

  changeSiteTitle(title: string): void {
    this._document.getElementById('appTitle').innerText = title;
  }
  changeDefaultLogo(href: string): void {
    this._document.getElementById('defaultlogo').setAttribute('src', href);
  }
  setSettingsData(sitename, logo, favicon) {
   

    this.logodata = this.Data;
      this.logodetail = this.logodata.data.logo;
      this.favdetails = this.logodata.data.favicon;

     
    let site, log, fav;
    site = sitename ? sitename : CONFIGCONSTANTS.siteName;
    
    log = this.logodetail ? this.logodetail : logo;
    fav = this.favdetails ? this.favdetails : favicon ;
   
    
    this.setting['sitename'] = site;
    this.setting['logo'] = log;
    this.setting['favicon'] = fav;
    // log = logo ? logo : 'assets/img/brand/logo.png';
    // log = logo ? logo : 'assets/img/brand/logo.png';

    // log = logo ? logo : 'assets/img/brand/logo_updated.png';
    // fav = favicon ? favicon : 'assets/img/brand/logo_icon.png';    
    
    // this.setting['sitename'] = site;
    // this.setting['logo'] = log;
    // this.setting['favicon'] = fav;

    // document.querySelector('img.navbar-brand-minimized')
    // $('img.navbar-brand-minimized').attr('src', fav);
    // $('img.navbar-brand-full').attr('src', log);
    // $('#appTitle').text(site);

    localStorage.setItem('settings', JSON.stringify(this.setting));
  }
}
